import { FC } from 'react'
import { Client } from '../../data/clients'

import { Container, Logo } from './ui'

interface ClientCardProps {
  className?: string
  item: Client
}

export const ClientCard: FC<ClientCardProps> = ({ className, item }) => {
  return (
    <a href={item.link} target="_blank" rel="noopener noreferrer">
      <Container className={className}>
        <Logo src={item.logo} />
      </Container>
    </a>
  )
}
